import { render, staticRenderFns } from "./IndicatorTile.vue?vue&type=template&id=8fe5bdc6"
import script from "./IndicatorTile.vue?vue&type=script&lang=js"
export * from "./IndicatorTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports